import classNames from "classnames";
import {observer} from "mobx-react";
import dynamic from "next/dynamic";
import FlatIcon from "../utilities/FlatIcon";
import FontAwesome from "../utilities/FontAwesome";
import styles from "./styles/FooterCS.module.scss";
import MailToLink from "../misc/MailToLink";
import * as React from "react";
import {useStores} from "../../stores/useStores";

const PhoneNumber = dynamic(() => import("../utilities/PhoneNumber"), {loading: () => <></>});

const addressColumnClassName = classNames({
    [styles.addressColumn]: true,
});

const FooterAddressColumn = observer(props => {
    const {organizationStore} = useStores();

    const location = organizationStore.organization.locations?.[0];

    let locationBlock = null;
    if (location) {
        locationBlock =
            <address aria-label={`Address for ${organizationStore.organization.title}`} className={"notranslate"}>
                {location.address && <p>{location.address}</p>}
                {location.address2 && <p>{location.address2}</p>}
                <p>{location.city ? `${location.city}, ` : ""}{location.state ? `${location.state} ` : ""}{location.zip ? location.zip : ""}</p>
            </address>
    }

    return (
        <div className={addressColumnClassName}>
            <h3 className={"notranslate"}>{organizationStore.organization.title}</h3>
            {locationBlock && <div>
                <div>
                    <FlatIcon ariaHidden={true} name={"flaticon-map"}/>
                </div>
                <div>
                    {locationBlock}
                </div>
            </div>}
            {locationBlock && location.phone && <div>
                <div>
                    <FlatIcon title="Primary Phone Number" ariaHidden={true} name={"flaticon-telephone-of-old-design"}/>
                </div>
                <div>
                    <PhoneNumber ariaLabel={`Call primary phone number ${location.phone}`} isLinked number={location.phone} description={location.phone_description}/>
                </div>
            </div>}
            {locationBlock && location.phone2 && <div>
                <div>
                    <FlatIcon title="Secondary Phone Number" ariaHidden={true} name={"flaticon-telephone-of-old-design"}/>
                </div>
                <div>
                    <PhoneNumber ariaLabel={`Call secondary phone number ${location.phone2}`} isLinked number={location.phone2} description={location.phone2_description}/>
                </div>
            </div>}
            {locationBlock && location.fax && <div>
                <div>
                    <FontAwesome title="Fax" ariaHidden={true} name={"fa-print"} prefix={"fas"}/>
                </div>
                <div>
                    <PhoneNumber ariaLabel={`Fax ${location.fax}`} number={location.fax} description={location.fax_description}/>
                </div>
            </div>}
            {locationBlock && location.email && <div>
                <div>
                    <FontAwesome title="Email" ariaHidden={true} name={"fa-at"} prefix={"fas"}/>
                </div>
                <div>
                    <MailToLink title={"Email"} recipient={location.email}>{location.email}</MailToLink>
                </div>
            </div>}
        </div>
    )
});

export default FooterAddressColumn;
